<template>
  <div v-if="coureurs.length > 0">
    <div class="select_fav">
      <b-button size="sm" class="button_select_fav inline-submenu-btn" v-for="(coureur, index) in coureurs" :key="index" @click="setSelected(index)" v-bind:class="{ favoris_selected: index === selected }"
        ><img class="flag" :src="'https://sportips.fr/live/img/Flags/' + coureur.nation + '.jpg'" /> {{ coureur.dossard }} {{ coureur.nom }} {{ coureur.prenom }}</b-button
      >
    </div>
    <div id="fiche_container" class="align_left" v-if="coureur.nom">
      <b-row>
        <b-col md="5">
          <h3>
            <img v-if="coureur.nation != ''" class="flag" :src="'https://sportips.fr/live/img/Flags/' + coureur.nation + '.jpg'" />{{ coureur.prenom }} {{ coureur.nom }}
            <span class="primary_color"><b> | </b></span>
            {{ $t("doss") }} n°
            <span class="primary_color">{{ coureur.dossard }}</span>
          </h3>
        </b-col>
        <b-col md="2">
          <div class="fiche_status" v-if="coureur.statut.text.includes('En course')">
            <p class="status_arrive" v-if="temps_de_course">En course : {{ temps_de_course }}</p>
          </div>
          <div v-else class="fiche_status" style="margin-bottom: 10px !important">
            <p v-if="coureur.statut.text.includes('Arrivé')" class="status_arrive"><v-icon name="check" /> {{ coureur.statut.text }}</p>
            <p v-else-if="coureur.statut.text.includes('Abandon') || coureur.statut.text.includes('Disqualifié')" class="status_abandon"><v-icon name="times" /> {{ coureur.statut.text }}</p>
            <p v-else class="status_autre"><v-icon name="ellipsis-h" />{{ coureur.statut.text }}</p>
          </div>
        </b-col>
        <b-col md="3">
          <InfoLocalisation :methode="coureur.tracking_methode"></InfoLocalisation>
        </b-col>
        <b-col md="2">
          <SelectFondMap></SelectFondMap>
        </b-col>
      </b-row>
      <p class="darkgrey_color">
        <span v-if="coureur.depart != '' && coureur.statut.depart"
          >Départ : <b>{{ coureur.depart }} | </b></span
        >
        <span v-else-if="coureur.depart != '' && coureur.heure_depart_theorique"
          >Départ prévu : <b>{{ coureur.heure_depart_theorique }} | </b></span
        >
        {{ $t("course") }} : <b>{{ coureur.course }}</b> <b> | </b>{{ $t("categorie") }} :
        <b>{{ coureur.cat }}</b>
        <b> | </b>{{ $t("club") }} :
        <b v-if="coureur.club.length > 0">{{ coureur.club }}</b>
        <b v-else>-</b>
      </p>

      <PassagesCoureur :key="selected + 'passage'" :passages="coureur.points" :statut="coureur.statut"></PassagesCoureur>

      <MapCoureur :key="lines.length + 'map'" v-if="lines.length > 0" :lines="lines" :coureur="coureur" :focus_point="focus_point"></MapCoureur>
      <ProfilCoureur :key="lines.length + 'profil'" v-if="lines.length > 0" :lines="lines" :coureur="coureur" :focus_point="focus_point" v-on:focus_point="setFocusPoint"></ProfilCoureur>
      <br />
      <p class="align_left">
        <b-button class="inline-submenu-btn with_icon" @click="removeFavoris()"><b-icon icon="x" aria-hidden="true"></b-icon> Retirer ce coureur de mes favoris</b-button>
      </p>
    </div>
  </div>
</template>

<script>
import toGeoJSON from "@mapbox/togeojson/togeojson.js";
import PassagesCoureur from "@/components/Live_tab/PassagesCoureur.vue";
import MapCoureur from "@/components/Live_tab/MapCoureur.vue";
import ProfilCoureur from "@/components/Live_tab/ProfilCoureur.vue";
import InfoLocalisation from "@/components/Live_tab/InfoLocalisation.vue";
import Loading from "@/components/Loading.vue";
import SelectFondMap from "@/components/FondMapSelector.vue";
import axios from "axios";
export default {
  components: {
    PassagesCoureur,
    MapCoureur,
    ProfilCoureur,
    Loading,
    InfoLocalisation,
    SelectFondMap,
  },
  props: ["favoris"],
  data() {
    return {
      coureurs: [],
      selected: 0,
      coureur: {},
      lines: [],
      focus_point: 0,
      temps_de_course: "",
    };
  },
  watch: {
    favoris() {
      this.fetchFavoris();
    },
  },
  methods: {
    setFocusPoint(p) {
      this.focus_point = p;
    },
    buildLines() {
      var _this = this;
      axios.get("https://sportips.fr/live/" + this.coureur.parcours.trace).then(function (response) {
        var geojson = toGeoJSON.gpx(new DOMParser().parseFromString(response.data, "text/xml"));
        _this.lines = geojson.features[0].geometry.coordinates;
        _this.$forceUpdate();
      });
    },
    removeFavoris() {
      this.$emit("removeFavoris", this.selected);
      this.selected = 0;
      this.coureur = this.coureurs[this.selected];
      if (this.coureur.parcours.trace) {
        this.buildLines();
      }
    },
    setSelected(index) {
      this.selected = index;
      this.coureur = this.coureurs[this.selected];
      if (this.coureur.parcours.trace) {
        this.buildLines();
      }
    },
    fetchFavoris() {
      var _this = this;
      axios.post(this.$store.state.base_url + "/live/favoris/get.php", { list_favoris: JSON.stringify(this.favoris), id_module: this.$store.state.module.id }).then(function (response) {
        _this.coureurs = response.data;
        _this.coureur = _this.coureurs[_this.selected];
        if (_this.coureur.parcours.trace) {
          _this.buildLines();
        }
      });
    },
    tempsCourseRefresh() {
      if (!this.$store.state.live_en_cours) {
        this.$store.commit("clearRefreshTempsCourseIntervals");
        return;
      }
      var _this = this;
      var intervalObject = setInterval(function () {
        _this.$store.commit("clearRefreshTempsCourseIntervals");
        var date_depart = _this.coureur.date_course.split("-");
        var heure_depart = _this.coureur.depart.split(":");
        if (date_depart.length > 2 && heure_depart.length > 2) {
          var timestamp_depart = new Date(date_depart[2], parseInt(date_depart[1]) - 1, date_depart[0], heure_depart[0], heure_depart[1], heure_depart[2]);
          var timestamp_now = Date.now();
          var temps_course = (timestamp_now - timestamp_depart) / 1000;
          _this.temps_de_course = _this.seconds2time(parseInt(temps_course));
        }
        _this.tempsCourseRefresh();
      }, 1000);
      this.$store.state.refreshTempsCourseIntervals.push(intervalObject);
    },

    seconds2time(seconds) {
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor((seconds - hours * 3600) / 60);
      var seconds = seconds - hours * 3600 - minutes * 60;
      var time = "";

      if (hours != 0) {
        time = hours + ":";
      }
      if (minutes != 0 || time !== "") {
        minutes = minutes < 10 && time !== "" ? "0" + minutes : String(minutes);
        time += minutes + ":";
      }
      if (time === "") {
        time = seconds + "s";
      } else {
        time += seconds < 10 ? "0" + seconds : String(seconds);
      }
      return time;
    },
    countdownRefresh() {
      if (!this.$store.state.live_en_cours) {
        this.$store.commit("clearRefreshIntervals");
        return;
      }
      var _this = this;
      var intervalObject = setInterval(function () {
        _this.$store.commit("clearRefreshIntervals");
        _this.fetchFavoris();
        _this.countdownRefresh();
      }, this.$store.state.refresh_time_carte);
      this.$store.state.refreshIntervals.push(intervalObject);
    },
  },
  created() {
    this.$store.commit("clearRefreshIntervals");
    this.$store.commit("clearRefreshTempsCourseIntervals");
  },
};
</script>

<style lang="scss" scoped>
</style>